export default __webpack_public_path__ + "static/media/PS5-3.606d8bab.jpg";